/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popPromptCompute.vue?vue&type=template&id=131118f2&scoped=true"
import script from "./popPromptCompute.vue?vue&type=script&lang=js"
export * from "./popPromptCompute.vue?vue&type=script&lang=js"
import style0 from "./popPromptCompute.vue?vue&type=style&index=0&id=131118f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131118f2",
  null
  
)

export default component.exports